module.exports = __webpack_public_path__ + "static/img/5.eb15658.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/5.png
// module id = sh5c
// module chunks = 0